const common = {
  // Navbar
  nav_glasses: '智能眼镜',
  nav_brand: '品牌故事',
  nav_dealer: '品牌加盟',
  nav_buy: '立即购买',
  nav_coming_soon: '敬请期待',

  // Video
  video_title: '看见下一个你',
  video_subtitle: '2分钟，读懂 NIMO 如何重塑专注',
  video_play_label: '点击观看品牌影片',

  // Hero
  hero_label: 'NIMO · 智能眼镜',
  hero_line1: '思绪归位',
  hero_line2: '心流自成',
  hero_desc: 'NIMO智能眼镜，过滤数字干扰，让你专注当下',
  hero_cta: '立即购买',

  // Brand
  brand_label: 'Brand Story',
  brand_title: '品牌故事',
  brand_italic: 'Reclaim Your Focus',
  brand_h3_1: '不是更多功能，',
  brand_h3_2: '而是更少干扰',
  brand_p1: 'NIMO 相信真正的智能不是堆砌更多功能，而是知道何时出现、何时隐身。我们将前沿 AI 技术与极致轻量的工业设计相融合，打造出既是科技工具、又能全天佩戴的智能眼镜。',
  brand_p2: '每一副 NIMO 智能眼镜背后，都藏着一个简单而深刻的信念：帮你过滤数字世界的干扰，让注意力重新属于你。',
  brand_cta: '探索NIMO',
  brand_quote: '\u300c 专注是这个时代最稀缺的奢侈品 \u300d',
  brand_v1_title: '仅仅是显示',
  brand_v1_desc: '自研引擎实时处理及过滤数字干扰，只保留真正需要你注意的内容，专注让你优雅、优秀。',
  brand_v2_title: '隐私优先设计',
  brand_v2_desc: '零摄像头，数据加密保护，可进入任何场景无隐私顾虑，避免社交尴尬。',
  brand_v3_title: '超轻舒适设计',
  brand_v3_desc: '钛合金 + 碳纤维框架，仅重 29g，与普通眼镜几乎无异，全天佩戴无压迫感。',

  // ValuePillars
  vp_label: 'Core Values',
  vp_title: '重新定义眼镜在你生活中的角色',
  vp_p1_cat: 'FOCUS',
  vp_p1_title: 'HUD显示，只留必要信息',
  vp_p1_body: '每天，你的大脑要处理 11 小时的数字信息流——邮件、消息、推送、弹窗。NIMO 智能眼镜帮你过滤数字干扰，只保留真正需要你注意的内容。这不是"少看手机"，而是重新定义什么值得你的注意力。',
  vp_p1_highlight: '重新定义什么值得你的注意力。',
  vp_p1_stat: '1500 nits',
  vp_p1_stat_label: '双目光波导',
  vp_p2_cat: 'PRIVACY',
  vp_p2_title: '零摄像头，准入任何场景',
  vp_p2_body: '不记录你的世界，只照亮你的路。NIMO 无摄像头智能眼镜——这不是技术妥协，而是隐私优先的战略选择。卧室、会议室、健身房、更衣室——任何场景都能自在使用。',
  vp_p2_highlight: '隐私由你完全掌控。',
  vp_p2_stat: '0',
  vp_p2_stat_label: '摄像头数量',
  vp_p3_cat: 'COMFORT',
  vp_p3_title: '29克，轻若无物',
  vp_p3_body: 'NIMO 只有 29 克——比一副太阳镜还轻。碳钎维镜框+β-TITANIUM镜腿，确保全天佩戴无压痕、无疲劳。单色显示同步降低视觉疲劳，续航更持久。',
  vp_p3_highlight: '舒适到让你忘记它的存在，直到你需要它。',
  vp_p3_stat: '29 g',
  vp_p3_stat_label: '整机重量',
  vp_bottom: '专注 · 隐私 · 舒适',

  // PillarDeepDive
  dd_label: 'In Depth',
  dd_title: '深入理解每一个维度',
  dd_1_label: '专注过滤',
  dd_1_title: '过滤噪音，找回被占据的专注力',
  dd_1_quote: '每天你的大脑要处理约 11 小时的数字信息流——邮件、消息、推送、弹窗。NIMO 智能眼镜帮你过滤数字干扰，只保留真正需要你注意的内容。',
  dd_1_highlight: '这不是"少看手机"，而是重新定义专注力。',
  dd_1_stat: 'HUD显示',
  dd_1_stat_desc: '不错过重要信息',
  dd_2_label: '隐私设计',
  dd_2_title: '技术，为体验隐身',
  dd_2_quote: 'NIMO 的每一项技术创新都服务于一个目标：让智能眼镜成为真正可以全天佩戴、不被察觉、不造成负担的日常工具。',
  dd_2_highlight: '避免社交尴尬，全场景使用。',
  dd_2_stat: '100%',
  dd_2_stat_desc: '无摄像头设计',
  dd_3_label: '佩戴舒适',
  dd_3_title: '全天佩戴无负担',
  dd_3_quote: '我们对上千名用户进行了佩戴测试，确保鼻梁和耳朵不会在长期佩戴后开始感到压迫。',
  dd_3_highlight: '舒适到让你忘记它的存在，直到你需要它。',
  dd_3_stat: '29g',
  dd_3_stat_desc: '超轻机身重量',

  // Testimonials
  test_label: 'Real Users',
  test_title: '真实场景 · 真的有用',
  test_subtitle: '用 NIMO 重获属于自己的专注时光',
  test_1_quote: '自动记录会议对话，AI提取关键要点、待办事项、决策结论。会后一键生成结构化纪要。',
  test_1_name: '李明',
  test_1_role: '产品经理',
  test_1_tag: 'AI 会议记录',
  test_2_quote: '演讲、汇报、直播时，提前导入文稿，内容进度AI自动识别显示。速度可调，支持暂停/跳转。自信表达，告别忘词尴尬。',
  test_2_name: '王医生',
  test_2_role: '医疗从业者',
  test_2_tag: '演讲提词',
  test_3_quote: '骑行时不用停下来看路线，导航提示轻轻出现在视野边缘，既安全又专注。这是我骑过最舒服的一段旅程。',
  test_3_name: '刘洋',
  test_3_role: '自由撰稿人',
  test_3_tag: 'HUD 导航',
  test_4_quote: '支持10+语言实时翻译，延迟低于2秒。对方说英语，你眼前浮现中文字幕；你说中文，对方手机侧看到英文。跨国会议不再紧张。',
  test_4_name: '陈思远',
  test_4_role: '旅行博主',
  test_4_tag: '跨国旅行',

  // Highlights
  hl_label: 'Core Technology',
  hl_title1: '技术，',
  hl_title2: '为体验隐身',
  hl_subtitle: '每项技术创新只为一个目标——让 NIMO 成为可全天佩戴、不被察觉、不造成负担的日常工具。',
  hl_f1_title: 'AI 智能信息过滤',
  hl_f1_desc: '自研 NimoFilter™ 引擎实时拦截干扰，有效减少无效注意力切换，帮助用户找回专注状态。',
  hl_f2_title: '体全息光波导显示',
  hl_f2_desc: '1500 nit 高亮度，阳光下清晰可读。体全息光栅波导技术，提供出色的视觉体验。',
  hl_f3_title: '单色显示 · 全天续航',
  hl_f3_desc: '单色显示功耗更低，正常使用 8–10 小时无需充电，待机可达 72 小时，支持快充。',
  hl_f4_title: 'IP54 气密性防护',
  hl_f4_desc: '独家气密性组装工艺，日常汗水、小雨无忧，多项专利保护。',
  hl_f5_title: '35g 超轻设计',
  hl_f5_desc: '拓扑优化框架，钛合金 + 碳纤维 + 医用硅胶，重量仅 35g，长时间佩戴舒适。',
  hl_f6_title: '端侧 AI · 隐私安全',
  hl_f6_desc: '零摄像头设计，所有 AI 在本地完成，数据不上云。符合 HIPAA/GDPR 相关要求。',
  hl_cta_title: '准备好重获专注了吗？',
  hl_cta_sub: '加入 NIMO 早鸟计划，成为首批重获专注的体验者。',
  hl_cta_btn1: '预约线下体验',
  hl_cta_btn2: '立即了解详情',

  // FAQ
  faq_label: 'FAQ',
  faq_title: '常见问题',
  faq_subtitle: '关于 NIMO 你最想知道的，都在这里。',
  faq_contact: '还有其他问题？',
  faq_btn1: '联系我们',
  faq_btn2: '预约演示',
  faq_q1: '为什么 NIMO 没有摄像头？',
  faq_a1: '这是我们的战略选择，不是技术限制。无摄像头设计让 NIMO 可以进入医院 ICU、会议室、健身房等任何场景，无需担心隐私风险或他人的怀疑目光。它也符合 HIPAA/GDPR 等严格的隐私法规，是进入医疗等 B2B 场景的"准入通行证"。',
  faq_q2: '单色显示会不会影响使用体验？',
  faq_a2: '恰恰相反，单色显示有三大优势：续航更持久，全天使用无需充电；视觉疲劳降低，长时间阅读不累眼；信息更纯粹，不会被色彩分散注意力。就像 Kindle 的电子墨水屏——长时间阅读不累眼，因为它只做一件事并做到出色。',
  faq_q3: 'NIMO 和普通智能眼镜有什么区别？',
  faq_a3: '普通智能眼镜追求"更多功能"，NIMO 追求"更少干扰"。我们的 AI 引擎会过滤数字噪音，只保留真正需要你注意的内容。35 克的超轻设计让你可以全天佩戴而不感到负担。我们不是做加法，而是做减法。',
  faq_q4: '能在阳光下看清屏幕吗？',
  faq_a4: '完全可以。NIMO 采用体全息光波导技术，亮度高达 3500 nit，即使在阳光直射下也能清晰阅读。相比之下，大多数智能眼镜在室外需要寻找阴影区域才能看清屏幕。',
  faq_q5: '需要配近视镜片吗？',
  faq_a5: 'NIMO 支持定制近视镜片（100-800 度）。如果你日常佩戴眼镜，可以选择配镜版本；如果视力正常或佩戴隐形眼镜，可以选择标准版。',
  faq_q6: '续航时间有多长？',
  faq_a6: '正常使用（每天查看信息 50-80 次）可使用 8-10 小时。重度用户续航约 6 小时。充电时间 90 分钟，支持快充。整机待机时间可达 72 小时。',
  faq_q7: '防水吗？',
  faq_a7: 'NIMO 的防护等级是 IP54，可以防护日常汗水、小雨和水花飞溅。不支持游泳或淋浴时佩戴，不建议完全浸入水中。',
  faq_q8: '支持哪些手机系统？',
  faq_a8: '支持 iOS 13 及以上、Android 8.0 及以上。通过蓝牙 5.2 连接手机，配对过程不到 1 分钟。',
  faq_q9: '数据安全吗？',
  faq_a9: 'NIMO 的所有数据处理都在本地完成，不上传云端。我们通过了 ISO 27001 信息安全认证和独立第三方隐私审计。你的信息完全由你掌控，我们无法访问。',
  faq_q10: '可以自定义信息过滤规则吗？',
  faq_a10: '完全可以。你可以在 APP 中设置哪些 APP 的通知会立即显示、哪些联系人的消息优先级最高，以及工作时段和休息时段的不同过滤策略。AI 引擎会学习你的习惯，逐渐优化过滤规则。',
  faq_q11: '戴久了会不会头晕？',
  faq_a11: 'NIMO 的显示位置经过精心设计，位于视野下方，不会遮挡正常视线。单色显示降低了视觉刺激强度，长时间使用不易疲劳。如果你初次使用，建议从每天 2-3 小时开始逐步适应。',
  faq_q12: '可以试用吗？',
  faq_a12: '个人用户可申请 7 天无理由退换（需保持产品完好）。企业和医疗机构可申请 30-60 天试点项目，免费提供设备和技术支持。',
  faq_q13: '质保政策是什么？',
  faq_a13: 'NIMO 提供 1 年质保，覆盖非人为损坏的硬件故障。质保期内免费维修或更换。超过质保期后，可享受优惠维修服务。',
  faq_q14: 'NIMO 适合我吗？',
  faq_a14: '如果你经常被手机通知打断工作、需要在开会/查房/运动时快速查看信息、重视隐私安全，或者希望减少数字干扰重获专注力，NIMO 很可能适合你。',
  faq_q15: '可以分期付款吗？',
  faq_a15: '支持花呗、信用卡分期（3/6/12 期），具体费率以支付平台为准。',

  // Footer
  footer_tagline: '重获专注，心流自成',
  footer_desc: '重新定义人与世界的连接方式，让每一次专注成为可能。',
  footer_nav: '导航',
  footer_products: '产品',
  footer_biz: '商务合作',
  footer_contact: '联系我们',
  footer_biz_label: '品牌·媒体合作',
  footer_nav_home: '首页',
  footer_nav_brand: '品牌介绍',
  footer_product_nimo: 'NIMO 智能眼镜',
  footer_copyright: '© 2026 BitFantasy Inc. 保留所有权利',
  footer_icp: '粤ICP备2025446590号',
  footer_agreement: '用户协议',
  footer_privacy: '隐私政策',
  footer_ad_notice: '本网站直接或间接向消费者推销商品或者服务的商业宣传均属于"广告"（包装及参数、售后保障等商品信息除外）',

  // Dealer page
  dealer_hero_label: '购买渠道 · 经销商加盟',
  dealer_hero_title: '与 NIMO 共同开创未来',
  dealer_hero_desc: '诚邀全国优质合作伙伴加入 NIMO 经销商网络，共享 AI 眼镜市场高速增长红利，携手构建下一代人机交互生态。',
  dealer_apply_label: 'Apply Now',
  dealer_apply_title: '立即申请成为\nNIMO 经销商',
  dealer_apply_desc: '填写申请表格，我们的商务团队将在 3-5 个工作日内与您取得联系，详细解答您的疑问并推进合作事宜。',
  dealer_contact_phone: '联系电话',
  dealer_contact_email: '商务邮箱',
  dealer_contact_time: '响应时效',
  dealer_contact_time_val: '3-5 个工作日',
  dealer_form_name: '联系人姓名',
  dealer_form_name_ph: '请输入姓名',
  dealer_form_phone: '联系电话',
  dealer_form_phone_ph: '请输入手机号',
  dealer_form_email: '邮箱地址',
  dealer_form_email_ph: '请输入邮箱',
  dealer_form_company: '公司 / 门店名称',
  dealer_form_company_ph: '请输入公司或门店名称',
  dealer_form_city: '所在城市',
  dealer_form_city_ph: '如：北京、上海',
  dealer_form_tier: '意向等级',
  dealer_form_tier_ph: '请选择',
  dealer_form_tier_silver: '银牌经销商（≥50台）',
  dealer_form_tier_gold: '金牌经销商（≥200台）',
  dealer_form_tier_diamond: '钻石经销商（≥500台）',
  dealer_form_error: '提交失败，请稍后重试或发送邮件至 partner@nimofantasy.ai',
  dealer_form_submit: '提交加盟申请',
  dealer_form_submitting: '提交中...',
  dealer_form_privacy: '提交即表示您同意 NIMO 收集并处理以上信息，仅用于加盟资质评估。',
  dealer_success_title: '申请已提交',
  dealer_success_desc: '感谢您的申请！我们的商务团队将尽快与您联系，请保持手机畅通。',
  dealer_success_reset: '重新填写',
};

export default common;
